import { commitLocalUpdate, useRelayEnvironment } from 'react-relay';
import type { ConnectionsSubscriberProps } from '@atlassian/jira-native-issue-table/src/common/types.tsx';
import { useSubscribeToBulkOperationsEvents } from '@atlassian/jira-bulk-operations-common/src/common/controllers/use-bulk-operations-pub-sub/index.tsx';
import RelayDataID from '@atlassian/relay-data-id';

export const BulkOpsConnectionsSubscriber = ({
	connections,
	updateConnectionDetails,
}: ConnectionsSubscriberProps) => {
	const environment = useRelayEnvironment();

	useSubscribeToBulkOperationsEvents('BULK_OPERATIONS_SUBMITTED', (payload) => {
		commitLocalUpdate(environment, (store) => {
			const deleteRelayDataIdSet = new Set(
				payload.payload
					.filter((p) => p.bulkOperationType === 'BULK_DELETE')
					.flatMap((p) => p.ariIssueIds.map((id) => RelayDataID({ id }, 'JiraIssue'))),
			);

			if (!deleteRelayDataIdSet.size) {
				return;
			}

			Object.values(connections).forEach((connection) => {
				const connectionRecord = store.get(connection.connectionId);

				if (!connectionRecord) {
					return;
				}

				const remainingEdges = connectionRecord.getLinkedRecords('edges')?.filter((edge) => {
					const node = edge?.getLinkedRecord('node');
					return node && !deleteRelayDataIdSet.has(node.getDataID());
				});

				connectionRecord.setLinkedRecords(remainingEdges, 'edges');
				updateConnectionDetails({
					store,
					connection,
					operation: 'remove',
					remainingIssueCount: remainingEdges?.length,
				});
			});
		});
	});

	return null;
};
